"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const Datagrid_1 = require("./../../../components/Datagrid");
const datagridProperties = [
    { sortKey: 'name', name: 'Name' },
    { sortKey: 'email', name: 'Email' },
    { sortKey: 'phone', name: 'Phone' },
    { sortKey: 'address.name', name: 'Address', thStyle: { flex: 2 } },
];
const data = [
    {
        id: '591b851b0ecc0efba5d6a8ff',
        name: 'Emma Bell',
        email: 'emmabell@solaren.com',
        phone: '+1 (916) 400-3830',
        address: '202 Regent Place, Convent, Utah, 2410',
    },
    {
        id: '591b851b5989fc95c3d9a821',
        name: 'Irma Reed',
        email: 'irmareed@solaren.com',
        phone: '+1 (804) 448-3011',
        address: '350 Gallatin Place, Gordon, North Carolina, 7386',
    },
    {
        id: '591b851b5bb9f941e11c76ba',
        name: 'Delgado Knapp',
        email: 'delgadoknapp@solaren.com',
        phone: '+1 (893) 542-3984',
        address: '454 Cove Lane, Westwood, Northern Mariana Islands, 7353',
    },
    {
        id: '591b851b8a71caa873073f2b',
        name: 'Marissa Wilder',
        email: 'marissawilder@solaren.com',
        phone: '+1 (893) 418-3661',
        address: '605 Rost Place, Rew, Delaware, 8809',
    },
    {
        id: '591b851b48693c73568dc89e',
        name: 'Claudine Alvarez',
        email: 'claudinealvarez@solaren.com',
        phone: '+1 (999) 598-3649',
        address: '502 Bragg Street, Imperial, South Carolina, 9047',
    },
    {
        id: '591b851b38676997a2a27b0c',
        name: 'Walsh Powers',
        email: 'walshpowers@solaren.com',
        phone: '+1 (864) 544-2598',
        address: '265 Manhattan Court, Bison, North Carolina, 2567',
    },
];
class ComplexDatagrid extends react_1.PureComponent {
    constructor() {
        super();
        this.state = {
            query: {
                limit: 50,
                skip: 0,
                sort: 'name',
            },
            searchTerm: '',
        };
        this.handleSearchTermChange = (searchTerm) => this.setState({ searchTerm });
        this.handleQueryChange = (query) => {
            this.setState({ query });
        };
        this.handleViewModeChange = (viewMode) => console.log('VIEW MODE', viewMode);
        this.mainButtonMetadata = {
            title: 'New Button',
            href: '#',
            onClick: () => console.log('new button clicked'),
        };
    }
    render() {
        const { query, searchTerm } = this.state;
        return (React.createElement(Datagrid_1.Datagrid, { mainButton: this.mainButtonMetadata, properties: datagridProperties, query: query, searchInputPlaceholder: "Search", searchTerm: searchTerm, total: data.length, onChangeQuery: this.handleQueryChange, onChangeViewMode: this.handleViewModeChange, onSearchTerm: this.handleSearchTermChange },
            React.createElement(Datagrid_1.DatagridTableView, { properties: datagridProperties }, data.map(item => (React.createElement("div", { key: item.id, className: "grid-tr" },
                React.createElement("div", { className: "grid-td" }, item.name),
                React.createElement("div", { className: "grid-td" }, item.email),
                React.createElement("div", { className: "grid-td" }, item.phone),
                React.createElement("div", { className: "grid-td", style: { flex: 2 } }, item.address))))),
            React.createElement(Datagrid_1.DatagridCardsView, null, data.map(item => (React.createElement("div", { key: item.id, className: "col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-2" },
                React.createElement("div", { className: "card" },
                    React.createElement("div", { className: "card-block" },
                        React.createElement("h4", { className: "card-title truncate" },
                            React.createElement("span", { className: " item-status active" }),
                            React.createElement("a", { href: "#", title: "Some St" }, "Some St")),
                        React.createElement("p", { className: "card-text" },
                            React.createElement("span", { className: "d-block truncate" },
                                "City:\u00A0",
                                React.createElement("strong", null, "Atlanta, GA")),
                            React.createElement("span", { className: "d-block truncate" },
                                "Street:\u00A0",
                                React.createElement("strong", null, "Some Street")),
                            React.createElement("span", { className: "d-block truncate" },
                                "Info C:\u00A0",
                                React.createElement("strong", null, "000000001111111111")))))))))));
    }
}
exports.ComplexDatagrid = ComplexDatagrid;



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/Datagrid/ComplexDatagrid.tsx
// module id = 472
// module chunks = 0